module.exports = __webpack_public_path__ + "static/img/defaultLocation.642cfdcd.png";